import { Component } from '@angular/core';

import { BaseCtrlValueAccessorFormComponent } from '@sim/form';

import { STC } from '@atmi/core/models';

@Component({
  selector: 'app-stc-form',
  styleUrls: ['./stc-form.component.scss'],
  templateUrl: './stc-form.component.html',
})
export class StcFormComponent extends BaseCtrlValueAccessorFormComponent<STC> {

  constructor() {
    super();
  }

}
